<template>

  <div >
    <div  class="home" style="width: 100vw; height: 100vh; display: flex; flex-direction: row; justify-content: center; align-items: center;">
    
    <nav v-show="showChat" class="navbar" style="background: #ebebeb; position: fixed; top: 0; width: 100%; z-index: 2;">
      <div class="container-fluid justify-content-center">
          <img class="navbar-brand" src="/img/now-logo3.png"/>
      </div>
    </nav>

    <div v-if="!showChat" style="margin: 50px 0px 0px 0px; ">
      <div class="row" style="margin: 0px 0px 50px 0px; ">     
        <div class="col" style="display: flex; justify-content: center; align-items: center;">
          <div style="display: flex; justify-content: flex-end;">
            <img src="/img/SAN_INTEIRO2.png" class="img-fluid" alt="">
            <!-- <img   src="/img/SAM_INTEIRO.png" style="width: 45%; max-height: 401px;"/> -->
          </div>
        </div>
        <div class="col-7" style="display: flex; justify-content: flex-start; align-items: center;">
          <div style="text-aling: left;">
            <h1 style="text-align: left; color: #27ae60; margin-bottom: 20px;">Oi, eu sou o <strong>Sam</strong></h1>
            <p style="text-align: left; color: #595959;">O novo assistente virtual da Samel!</p>
            <p style="text-align: left; color: #595959;">Para iniciar o atendimento, clique no botão abaixo:</p>
            <p style="text-align: left; margin-top: 30px;"><button type="button" class="btn btn-success btn-inicial" @click="showChat = !showChat">Iniciar o Atendimento</button></p>
          </div>
        </div>
      </div>

      <div style="border-top: solid 3px #215a41; background: #ffffff; max-width: 800px;" class="container">
        
          <p style="text-align: left; padding: 10px 10px 0px 10px;">Olá, tudo bem?</p>
          <p style="text-align: left; padding: 0px 10px 10px 10px;">O Sam foi desenvolvido pelos desenvolvedores da Samel Health Tech, primeiro laboratório de desenvolvimento
            de novas tecnologias voltadas para a área da saúde das regiões Norte e Nordeste do Brasil e tem o intuito 
            de trazer mais cuidado e rapidez no seu contato com a nossa equipe!
          </p>
      </div>

    </div>

   

    <!-- <div v-if="!showChat" style="background: #f66a6a;"> 

      <div class="text-center" style="margin: auto; padding: 0px 0px 0px 0px; background: #f66ad3;" >
        <transition name="bounce">
          <div id="textoInicial" v-if="show">
            <p class="card-text" style="text-align: left; margin: 5px 8px 0px 8px; font-size: 20px; font-family: Courier New;">Olá, eu sou o <strong>Sam</strong>, o bot online da Samel.</p>
            <p class="card-text" style="text-align: left; margin: 0px 8px 5px 8px;  font-size: 20px; font-family: Courier New;">Click <strong><a href="#" @click="showChat = !showChat">aqui</a></strong> para iniciar o atendimento.</p>
          </div>
        </transition>

        <p v-show="!show">
        <button @click="show = !show" type="button" class="btn btn-success btn-inicial">Iniciar</button>
        </p>

        <img  v-if="show" src="/img/SAM_INTEIRO.png" style="width: 25%; margin-top: 20px;"/>
        <img  v-else src="/img/SAM_INTEIRO_DORMINDO.png" style="width: 25%; margin-top: 20px;"/>
        
      </div>

    </div> -->

    <ChatBot class="col-12" v-if="showChat"/>

    </div>
     

    <!-- <ChatBot class="col-12" v-if="showChat"/> -->

     <!--  <div class="" v-if="!showChat">
        <img class="col-2 offset-10 mx-auto mb-4 icone" src="/img/chatbot.svg" width="80" @click="showChat = !showChat"/>
        <h2 class="col-12 bg-light rounded p-2">Toque no ícone para iniciar o Atendimento</h2>
      </div> -->
    <div class="rodape" v-if="!showChat">
      <p>Desenvolvido por Samel Health Tech © 2021</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChatBot from "@/components/ChatBot.vue";

export default {
  name: "Home",
  data() {
    return {
      show: false,
      showChat: false
    }
  },
  components: {
    ChatBot
  },

  mounted(){
    // this.show = true;
  }
};
</script>

<style scoped>
#textoInicial{
  -webkit-box-shadow: 0px 0px 13px -5px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 13px -5px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 13px -5px rgba(0,0,0,0.75);
  background: #ececec; 
  width: 90%; 
  max-width: 530px; 
  margin: 0 auto; 
  padding: 10px 5px 10px 5px; 
  border-radius: 10px 10px 10px 10px; 
  -moz-border-radius: 10px 10px 10px 10px; 
  -webkit-border-radius: 10px 10px 10px 10px;
}

.btn-inicial{
  background: #215a41;
  border: solid 1px #215a41;
}

.btn-inicial:hover{
  background: #31805d;
  border: solid 1px #31805d;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
}

.btn-inicial:active{
  background: #31805d;
  border: solid 1px #31805d;
}

.home{
  width: 100%;
  height: 100%;
}

.container{
  height: 100%;
}

.icone{
  cursor: pointer;
}


.bounce-enter-active {
  animation: bounce-in .9s;
}
.bounce-leave-active {
  animation: bounce-in .9s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.btn-inicial{
  background: #215a41;
  border: solid 1px #215a41;
  border-radius: 109px 109px 109px 109px;
-moz-border-radius: 109px 109px 109px 109px;
-webkit-border-radius: 109px 109px 109px 109px;
}

.btn-inicial:hover{
  background: #31805d;
  border: solid 1px #31805d;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
}

.btn-inicial:active{
  background: #31805d;
  border: solid 1px #31805d;
}
.rodape{
  width: 100%;
  position: fixed;
	bottom: 0;
  background: #d5d5d5;
  padding-top: 15px; 
}
</style>
